// extracted by mini-css-extract-plugin
export var lg = "_du-7";
export var md = "_du-6";
export var placeholderContainer = "_du-1";
export var placeholderIcon = "_du-2";
export var productImage = "_du-0";
export var sm = "_du-5";
export var xl = "_du-8";
export var xs = "_du-4";
export var xxs = "_du-3";